import type { ConversationPreview } from "@somewear/messaging";

import { DM_MEDIA_ROOM_SEPERATOR } from "./mediaComms.rooms.model";
import { MediaRoom } from "./mediaComms.rooms.state";

export const isWorkspaceMediaRoom = (room: MediaRoom): boolean => {
	return !room.name.includes(DM_MEDIA_ROOM_SEPERATOR);
};

export const roomMatchesAccountIds = (roomName: string, accountIds: string[]): boolean => {
	const roomAccountIds = roomName.split(DM_MEDIA_ROOM_SEPERATOR).sort();
	const sortedAccountIds = [...accountIds].sort();
	if (roomAccountIds.length !== sortedAccountIds.length) return false;
	return roomAccountIds.every((id, i) => id === sortedAccountIds[i]);
};

export function findRoomForConversation(
	rooms: MediaRoom[],
	selfAccountIds: string[],
	conversation: ConversationPreview,
): MediaRoom | undefined {
	if (conversation.workspaceId) {
		return rooms.find((r) => r.name === conversation.workspaceId);
	}
	return rooms.find(
		(r) =>
			r.type === "direct" &&
			conversation.participantId != null &&
			selfAccountIds.some((selfId) =>
				roomMatchesAccountIds(r.name, [selfId, conversation.participantId!]),
			),
	);
}
